import React from 'react';
import './App.css';
import 'tachyons';

const Contact =() => {
  return (
    <div id="Contact" className="parallax" >
      <h1 className="contact-heading1 f1">Contact</h1>
        <form className="pa4 gform db w-100 measure2 form" method="POST" data-email="example@email.net" 
        action="https://script.google.com/macros/s/AKfycbwB7wV0PKkPZU5LvtBmzReqYBk-HTxwt_nlvdI5KRkHiTGcKpU/exec">
          <div>
            <label htmlFor="comment" className="f4 db mb2">Comments</label>
            <textarea id="comment" name="comment" className="db border-box hover-black w-100 measure ba b--black-20 pa2 br2 mb2" aria-describedby="comment-desc"></textarea>
          </div>
          <div className="mt3">
            <label className="db fw4 lh-copy f4" htmlFor="email-address">Email address</label>
            <input className="pa2 input-reset ba bg-white w-100 measure br2 mb2" type="email" name="email-address"  id="email-address" required />
           
            <div className="thankyou_message">
 
              <h3>Thanks for contacting me! I will get back to you soon!
              </h3>
            </div>
              <div className="mt3">
                <input className="b ph3 pv2 input-reset ba b--black grow pointer bg-white f4 br2" type="submit" value="Send" />
          </div>
        </div>
      </form>

      <div className="SocialMedia pa5 ">
      
      <a href="https://twitter.com/Chantelletjie71">
        <img src="https://img.icons8.com/cotton/64/000000/twitter.png" alt="twitter-link" className="grow" />
      </a>
      
      <a href="https://github.com/chantelletjie">
        <img src="https://img.icons8.com/nolan/64/github.png" alt="github-link" className="grow" />
      </a>
      
      </div>

    </div>

    

  );
}

export default Contact;